import axios from "axios";
import { useDispatch } from "react-redux";
import { zl } from "../../../functions/utilities";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';
import { 
    fetchRozliczenieWodyWmSaved
} from "../../../Redux/Actions";

const WodaOdczytyRazemSzczegolyWm3 = props => {

    const { wybraneRozliczenie, czyWmSavedAkt } = props;
    const dispatch = useDispatch();

    const update = async () => {
        const {abonamentRazem, abonament_dzien, cieplaWmKoniec, cieplaWmPoczatek, energiaPobrana, id, id_wspolnoty, kosztPodgrzaniaCieplej, 
            kosztPodgrzaniaRazem, kosztZimnejRazem, liczbaMsc, metr_3_zimnej, metrazRazem, miesiac, mocZamowiona, okresKoniec, okresPoczatek, opis, 
            opublikowany, podgrzanieWody, razemZwCwAboTotal, saldoTotal, strata, strataTotal, zaliczkaAbonament, zaliczkaCieplaTotal, zaliczkaTotal, 
            zaliczkaZimnaTotal, zimnaWmKoniec, zimnaWmPoczatek, zuzycieM, zuzycieMCiepla, zuzycieMZimna, zuzycieWmCiepla, zuzycieWmZimna
        } = wybraneRozliczenie;

        try {
            axios.post("/api/rozliczenie-wm/dodaj", { 
                abonamentRazem, 
                abonament_dzien, 
                cieplaWmKoniec, 
                cieplaWmPoczatek, 
                energiaPobrana, 
                id_odczytu_wm: id, 
                id_wspolnoty, 
                kosztPodgrzaniaCieplej, 
                kosztPodgrzaniaRazem, 
                kosztZimnejRazem, 
                liczbaMsc, 
                metr_3_zimnej, 
                metrazRazem, 
                miesiac, 
                mocZamowiona, 
                okresKoniec, 
                okresPoczatek, 
                opis, 
                opublikowany, 
                podgrzanieWody, 
                razemZwCwAboTotal, 
                saldoTotal, 
                strata, 
                strataTotal, 
                zaliczkaAbonament, 
                zaliczkaCieplaTotal, 
                zaliczkaTotal, 
                zaliczkaZimnaTotal, 
                zimnaWmKoniec, 
                zimnaWmPoczatek, 
                zuzycieM, 
                zuzycieMCiepla,
                zuzycieMZimna, 
                zuzycieWmCiepla, 
                zuzycieWmZimna
            }).then(response => {
                dispatch(fetchRozliczenieWodyWmSaved(id_wspolnoty)); 
                update_mieszkancy();
            })
        } catch (error) {
            console.error('Błąd podczas dodawania danych:', error);
        } 
    } 

    const update_mieszkancy = async () => {
        wybraneRozliczenie?.procenty?.forEach( procent => {
            const { abonament, abonament_pozorny_msc, abonament_pozorny_mnoznik, czyRozliczac, grupa_numer, id_odczytu_wm, id_user, id_wspolnoty, 
                kosztZimnej, metraz, opis, podgrzanieWody, procMieszkanca, razemZwCwAbo, saldo, strataMieszkancaKwota, strataMieszkancaMetry, 
                zaliczka_abo_cw, zaliczka_cw, zaliczka_razem, zaliczka_zw, zuzycieMieszkanca, zuzycieMieszkancaCiepla, zuzycieMieszkancaZimna, 
                ile_dni } = procent;
            try {
                axios.post("/api/rozliczenie-m/dodaj", {
                    abonament, 
                    abonament_pozorny_msc,
                    abonament_pozorny_mnoznik,
                    czyRozliczac, 
                    grupa_numer, 
                    id_odczytu_wm, 
                    id_user, 
                    id_wspolnoty, 
                    kosztZimnej, 
                    metraz, 
                    opis, 
                    podgrzanieWody, 
                    procMieszkanca, 
                    razemZwCwAbo, 
                    saldo, 
                    strataMieszkancaKwota, 
                    strataMieszkancaMetry, 
                    zaliczka_abo_cw, 
                    zaliczka_cw, 
                    zaliczka_razem, 
                    zaliczka_zw, 
                    zuzycieMieszkanca, 
                    zuzycieMieszkancaCiepla, 
                    zuzycieMieszkancaZimna,
                    ile_dni
                }).then(response => {

            })
            } catch (error) {
            console.error('Błąd podczas dodawania danych:', error);
            } 
        })
    }

    const aktualne = () => {
        if (czyWmSavedAkt && wybraneRozliczenie?.opublikowany) {
            return (
                <p className="opis">
                    Dane aktualne
                    <FontAwesomeIcon
                        icon={faCircleCheck}
                        onClick={update}
                        style={{color: "var(--greenCurrent)"}}
                    />
                </p>
            )
        } else if (!czyWmSavedAkt && wybraneRozliczenie?.opublikowany) {
            return (
                <p className="opis">
                    Aktualizuj 
                    <FontAwesomeIcon 
                        icon={faCloudArrowUp} 
                        onClick={update}
                        style={{color: "var(--blueUpdate)"}}
                    />
                </p>
            ) 
        } else {
            return (
                <p></p>
            )
        }
    }

    return (
        <div className="blok">
            <div className="woda-wiersz">
                <p className="opis">
                    Koszt 1m³ zimnej wody (wg PWiK):
                </p>
                <p className="zuzycie">
                    {`${zl(wybraneRozliczenie?.metr_3_zimnej)}`}
                </p>
            </div>
            <div className="woda-wiersz">
                <p className="opis">
                    Czy opublikowany:
                </p>
                <p className="zuzycie">
                    {`${wybraneRozliczenie?.opublikowany ? 'Tak' : 'Nie'} (${wybraneRozliczenie?.miesiac || 'Brak daty'})`}
                </p>
            </div>
            <div className="woda-wiersz">
                    { aktualne() }
            </div>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyWm3;